import { analyticsApi } from "@/modules/analytics/api";
import { configureStore } from '@reduxjs/toolkit';
import { authApi } from './authApi';
import { conditionGroupsLookupsApi } from '@entities/condition-groups/api';
import { specialitiesApi } from '@entities/specialities/api';
import { organizationsApi } from '@entities/organizations/api';
import { paymentProvidersApi } from '@entities/payment-providers/api';
import { conditionResourcesLookupsApi } from '@entities/condition-resources/api';
import { conditionLookupsApi } from '@entities/conditions/api';
import { qrCodesApi } from '@entities/qr-codes/api';
import { usersApi } from '@entities/users/api';
import { filesApi } from '@entities/files/api';
import { clarityActionSanitizer, clarityStateSanitizer } from '@entities/clarity/devtools-sanitizer';

export const store = configureStore({
  reducer: {
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [conditionGroupsLookupsApi.reducerPath]: conditionGroupsLookupsApi.reducer,
    [specialitiesApi.reducerPath]: specialitiesApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [paymentProvidersApi.reducerPath]: paymentProvidersApi.reducer,
    [conditionResourcesLookupsApi.reducerPath]: conditionResourcesLookupsApi.reducer,
    [conditionLookupsApi.reducerPath]: conditionLookupsApi.reducer,
    [qrCodesApi.reducerPath]: qrCodesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [filesApi.reducerPath]: filesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(conditionGroupsLookupsApi.middleware)
      .concat(specialitiesApi.middleware)
      .concat(organizationsApi.middleware)
      .concat(paymentProvidersApi.middleware)
      .concat(conditionResourcesLookupsApi.middleware)
      .concat(conditionLookupsApi.middleware)
      .concat(qrCodesApi.middleware)
      .concat(usersApi.middleware)
      .concat(filesApi.middleware),
  // Keep DevTools on, but never record the Clarity catalog token in its history.
  devTools: {
    actionSanitizer: clarityActionSanitizer,
    stateSanitizer: clarityStateSanitizer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 